<template>
  <div class="min-h-screen bg-[#F8F3ED]">
    <div class="mx-auto max-w-7xl px-4 py-10 lg:px-8">
      <section class="space-y-6">
        <RouterView />
      </section>
    </div>
  </div>
</template>

<script setup>
import { RouterView } from 'vue-router'
</script>
